import script from "./EditEmployeeDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditEmployeeDetails.vue?vue&type=script&lang=ts&setup=true"

import "./EditEmployeeDetails.vue?vue&type=style&index=0&id=e53edd16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e53edd16"]])

export default __exports__